<svg width="20" height="9" viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<path d="M11.3379 7.79586C10.5773 8.48041 9.42268 8.48041 8.66207 7.79586L-7.86805e-07 1.74846e-06L20 0L11.3379 7.79586Z" fill="white"/>
</svg>
